import { PostMedicationDispense } from "@/services/fhir/patientsummary/medicationdispense/PostMedicationDispense";
import type {
  BuildPurchaseReleaseBatchParams,
  LocalPurchaseReleaseBatch,
} from "src-next/modules/patient-supporting-documents";

export const ecommercePurchaseReleaseService = {
  submitPurchaseRelease(
    params: BuildPurchaseReleaseBatchParams,
  ): Promise<LocalPurchaseReleaseBatch> {
    return PostMedicationDispense(params);
  },
};
